inputs-password
  div(class="form-group row { error: opts.errors }")
    label.col-md-4.col-form-label(for="example-text-input")
      | { opts.label }
      span.text-danger(if="{ opts.required }") &nbsp;*
    .col-md-8
      input(if="{!opts.disabled}" class="form-control" name="{ opts.name }" placeholder="{ opts.placeholder }" type="password" value="{ opts.value }" onInput="{this.onInput}" onChange="{this.onChange}")
      input(if="{ opts.disabled}" class="form-control" name="{ opts.name }" placeholder="{ opts.placeholder }" type="password" value="{ opts.value }" onInput="{this.onInput}" onChange="{this.onChange}" disabled="disabled")
      div.help-block(if="{ opts.errors }")
        ul(role="alert")
          li.text-danger.error(each="{message in opts.errors}") { message }
  script(type="typescript").
    this.mixin('inputs.password');
